module.exports = __webpack_public_path__ + "img/appBar.ddfbda47.png";